import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { EmailConfigService } from 'src/app/private/services/emailconfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-email-config',
  imports: [SharedModule],
  templateUrl: './delete-email-config.component.html',
  styleUrl: './delete-email-config.component.scss'
})
export class DeleteEmailConfigComponent {
  @Input() emailConfigDataToEdit: any = null;
  @Input() clientId: string = '';
  isLoading = false;

  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  constructor(
    private emailConfigService: EmailConfigService,
    private messageService: MessageService
  ) { }


  handleCloseDialog() {
    this.close.emit();
  }

  handleDeleteDepartment() {
    this.isLoading = true; // Set loading state to true
    const payload = {
      id: this.emailConfigDataToEdit.id,
    };
    this.emailConfigService.deleteEmailConfig(payload).subscribe(
      {
        next: (res: any) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Department deleted successfully'
          });
          this.reload.emit(); // Emit reload event to parent component
          this.close.emit(); // Emit close event to parent component
        },
        error: (err) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error?.message || 'An error occurred while deleting the department'
          });
        }
      }
    );
  }

}
